import React, {
  useEffect, Fragment, useState, useRef
} from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import FooterComponent from '@components/common/footer';
import { APP_CONFIG } from '@constants';
import cn from 'classnames';
import {
  updateMultiCart,
  onSearchItem,
  pushMenuItemsByScreenId,
  clearMenu,
  replaceCart,
  getMultiMenu,
  upsellCheck,
  getMenu,
  getMenuBasedOnLanguage,
  onContinousScrollSearchItem,
  // setIsOpenDrawer,
  setOrderNickNameDrawer,
  // setCheckoutSlider,
  setUpsellDrawer,
  setSearchString,
  setActiveCategory,
  showLanguageModal
} from '@reducers/orders';
import { bindActionCreators } from 'redux';
import { toggleFooter, toggleCancelButtonSamePage, updateHeaderData } from '@reducers/header';
import { callServer } from '@reducers/pingServer';
import { setNotification } from '@reducers/notification';
import styles from './footer.module.css';
import { getObjectValue } from '@utility/utills';
import DesktopMenu from '@components/common/footer/desktopMenu';
import { logout } from '@reducers/oauth';
import { sessionTrack, updatePopInData } from '@reducers/controller';
import Modal from '@components/common/Modal';
import find from 'lodash/find';
import MallMenuModal from '@components/MallMenuModal';
import { CUSTOM_MESSAGES } from '@veriables';
import { getStoreThemeUrl, getLanguageThemeUrl } from '@reducers/theme';
import { useNavigate } from 'react-router-dom';
import { setCheckoutModal, setUpsellModal } from '../../../reducers/orders';

const Footer = (props) => {
  const { menus, menu, closeButton } = props;
  const {
    footer,
    popInData,
    action,
    wishListCount,
    headerBar,
    themeProperties,
    menuItems
  } = props;
  const {
    isOpenDrawer, isCheckoutSlider, isUpsellDrawer, orderNickNameDrawer, ordersSearchString,
  } = useSelector(state => state.orders);
  const isIos = JSON.parse(window.localStorage.getItem('ios'));
  const suppressfooter = getObjectValue(() => popInData.suppressFooterIcons, false);
  const [search, onChangeSearch] = useState(ordersSearchString);
  const [isSearching, setIsSearching] = useState(false);
  const [showRestaurants, setShowRestaurants] = useState(false);
  const [activeCart, setActiveCart] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const drawerOpen = (!window.location.pathname === '/order-item' && orderNickNameDrawer) || (window.location.pathname === '/orders' && orderNickNameDrawer);

  const accountPaths = [
    '/account',
    '/optin',
    '/wallet',
    '/wallet/loyalties',
    '/orders-history',
    '/profile/basicInfo',
    '/wallet/address',
  ];
  const accountCart = accountPaths.includes(window.location.pathname);
  const currentStepIndex = window.sessionStorage.getItem('currentView');

  useEffect(() => {
    window.scrollTo(0, 0);
    const headerData = {
      footer: {
        show: (window.location.pathname === '/selected-cart/0' && popInData.flowType === 2) || !(isOpenDrawer || isUpsellDrawer || orderNickNameDrawer || accountCart || currentStepIndex)
      }
    };
    dispatch(updateHeaderData(headerData));
  }, [isOpenDrawer, dispatch, drawerOpen, isUpsellDrawer]);

  const getActivityType = (type) => {
    let activityType = '';
    switch (type) {
      case 1:
      case 16:
        activityType = 'nav_home';
        break;
      case 2:
        activityType = 'nav_browse';
        break;
      case 3:
        activityType = 'nav_favorite';
        break;
      case 6:
        activityType = 'nav_order';
        break;
      default:
        activityType = '';
    }
    return activityType;
  };

  const handleSessionTrack = () => {
    const dataToSend = {
      activityType: 'nav_menu',
      data: {}
    };
    props.sessionTrack(dataToSend);
  };

  const onSearch = () => {
    if (search.length > 0) {
      props.onSearchItem(search);
    } else if (search.length > 0) {
      props.onContinousScrollSearchItem(search);
    }
  };

  const handleSearchSessionTrack = () => {
    const dataToSend = {
      activityType: 'search_menu_item',
      data: {
        searchText: search,
        // count: props.screenMenuItemsList.length
      }
    };
    props.sessionTrack(dataToSend);
    setIsSearching(false);
  };

  useEffect(() => {
    if (isSearching) {
      handleSearchSessionTrack();
    }
  }, [props.screenMenuItemsList, isSearching]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (search) {
        props.onSearchItem(search).then(() => {
          setIsSearching(true);
        });
      }
      if (search) {
        props.onContinousScrollSearchItem(search).then(() => {
          setIsSearching(true);
        });
      }
    }, 700);

    return () => clearTimeout(delayDebounceFn);
  }, [search]);

  const onSearchChange = (string) => {
    dispatch(setSearchString(string));
    onChangeSearch(string);
    if (!string) {
      const menuScreenRaw = window.sessionStorage.getItem('menuScreen');

      const menuScreen = menuScreenRaw && menuScreenRaw !== 'undefined'
        ? JSON.parse(menuScreenRaw)
        : null;
      dispatch(setActiveCategory(menuScreen));
      const menuTypeId = window.sessionStorage.getItem('menuTypeId');
      if (menuTypeId) props.pushMenuItemsByScreenId(Number(menuTypeId));

      return;
    }
    const matchedScreen = props.menusList[props.menuIndex]?.screens?.find(screen => screen.menuItemLinks?.some((item) => {
      const name = getObjectValue(
        () => menuItems[item.menuItemId].name,
        ''
      );
      return name.toLowerCase().includes(string);
    }));
    if (matchedScreen) {
      dispatch(setActiveCategory(matchedScreen));
    }
    if (string === '') {
      // dispatch(setActiveCategory(menus[0]));
      dispatch(pushMenuItemsByScreenId(Number(window.sessionStorage.getItem('menuTypeId'))) || '');
    }
  };

  const navigateTo = (url, type) => {
    if (['/account', '/profile-feature'].includes(url)) {
      window.sessionStorage.setItem('footer', JSON.stringify(props.footer));
      window.sessionStorage.setItem('accountPageToRedirect', window.location.pathname);
    }
    const dataToSend = {
      activityType: getActivityType(type),
      data: {}
    };
    props.sessionTrack(dataToSend);
    props.pushMenuItemsByScreenId(Number(window.sessionStorage.getItem('menuTypeId')));
    navigate(`${APP_CONFIG.BASE_URL}${url}`);
  };

  useEffect(() => {
    try {
      window.webkit.messageHandlers.submitToiOS.postMessage(JSON.stringify({ cart: props.cart }));
    } catch (err) {
      // console.log('error');
    }
    try {
      window.Android.submitToAndroid(JSON.stringify({ cart: props.cart }));
    } catch (err) {
      // console.log('error');
    }
  }, [props.cart]);

  const closeOnSamePage = () => {
    props.toggleCancelButtonSamePage(true);
  };

  const getCartQuantity = () => {
    let count = 0;
    props.cart.forEach((item) => {
      count += item.quantity;
    });
    return count;
  };

  const getSelectedLanguage = () => {
    const langId = window.sessionStorage.getItem('languageId') || getObjectValue(() => themeProperties.languageId, null);
    let result = getObjectValue(() => themeProperties.languageId, null);
    if (langId) {
      result = Number(langId);
    }
    return result;
  };

  const [selectedLanguageId, setSelectedLanguageId] = useState(getSelectedLanguage());
  const [prevLang, setPrevLang] = useState();
  const prevLangRef = useRef();
  const languageChange = window.sessionStorage.getItem('languageId');
  useEffect(() => {
    prevLangRef.current = selectedLanguageId;
    setPrevLang(prevLangRef.current);
  }, [languageChange]);

  useEffect(() => {
    onSearchChange(ordersSearchString);
  }, [ordersSearchString]);

  const handleMenuSelectionBasedOnLanguage = (languageId) => {
    const cartItems = window.sessionStorage.getItem('cart') !== 'null' ? window.sessionStorage.getItem('cart') : [];
    if (prevLang !== languageId) { // condition to prevent call menu again
      props.clearMenu().then(() => {
        props.getMenuBasedOnLanguage(getObjectValue(() => popInData.store.id, null), popInData.flowType, languageId).then(() => {
          if (cartItems && cartItems.length > 0) {
            props.replaceCart(JSON.parse(cartItems));
          }
        });
      });
    }
  };

  // const handleLanguageSelection = (languageId) => {
  //   setSelectedLanguageId(languageId);
  //   if (languageId && languageId !== selectedLanguageId) {
  //     window.sessionStorage.setItem('languageId', languageId);
  //     props.getLanguageThemeUrl(getObjectValue(() => popInData.store.brandId, null), getObjectValue(() => popInData.store.id, null), languageId).then((res) => {
  //       setIsLanguageModalOpen(false);
  //       if (res.appCustomizationUrl) {
  //         handleMenuSelectionBasedOnLanguage(languageId);
  //       } else {
  //         props.getLanguageThemeUrl(getObjectValue(() => popInData.store.brandId, null), getObjectValue(() => popInData.store.id, null), 1);
  //         handleMenuSelectionBasedOnLanguage(1);
  //       }
  //     });
  //   } else if (languageId && languageId === selectedLanguageId) {
  //     setIsLanguageModalOpen(false);
  //   }
  // };
  const handleLanguageSelection = (languageId) => {
    const selectedId = languageId || 1;

    setSelectedLanguageId(selectedId);
    window.sessionStorage.setItem('languageId', selectedId);
    dispatch(showLanguageModal(false));
    if (selectedId !== selectedLanguageId) {
      props
        .getLanguageThemeUrl(
          getObjectValue(() => popInData.store.brandId, null),
          getObjectValue(() => popInData.store.id, null),
          selectedId
        )
        .then((res) => {
          if (res.appCustomizationUrl) {
            handleMenuSelectionBasedOnLanguage(selectedId);
          } else {
            props.getLanguageThemeUrl(
              getObjectValue(() => popInData.store.brandId, null),
              getObjectValue(() => popInData.store.id, null),
              1
            );
            handleMenuSelectionBasedOnLanguage(1);
          }
        });
    } else {
      dispatch(showLanguageModal(false));
    }
  };

  const isMobile = window.innerWidth < 1023;
  const onClickCartHandler = () => {
    const dataToSend = {
      activityType: 'nav_bag',
      data: {}
    };
    setActiveCart(true);
    props.sessionTrack(dataToSend);
    if (isMobile) {
      dispatch(setOrderNickNameDrawer(false));
      if ((!window.sessionStorage.getItem('cart') || (JSON.parse(window.sessionStorage.getItem('cart'))?.length === 0)) && popInData.flowType !== 2 && popInData.flowType !== 11) {
        dispatch(setCheckoutModal(true));
        dispatch(setUpsellDrawer(false));
      } else if (popInData.flowType === 2 || popInData.flowType === 11) {
        navigate(`${APP_CONFIG.BASE_URL}/upsell`);
      } else {
        dispatch(setUpsellDrawer(true));
      }
    } else {
      navigate(`${APP_CONFIG.BASE_URL}/upsell`);
    }
  };

  const sliderHandler = () => {
    if (!isMobile) {
      const isUpsell = window.sessionStorage.getItem('isUpsell') === 'false';

      if (isUpsell) {
        window.sessionStorage.setItem('currentView', 'bag');
        navigate(`${APP_CONFIG.BASE_URL}/selected-cart/0`);
      } else {
        const cartQty = getCartQuantity();

        if (cartQty > 0) {
          dispatch(setUpsellModal(true));
        } else {
          dispatch(setCheckoutModal(true));
        }
      }
    }
  };


  const onPreviewSync = () => {
    const storeId = getObjectValue(() => props.popInData.store.id, 0);

    const menuId = sessionStorage.getItem('MenuId');
    const menuType = sessionStorage.getItem('MenuType');

    navigate(
      `${APP_CONFIG.BASE_URL}/preview/orders?storeId=${storeId}&menuId=${menuId}&menuType=${menuType}`
    );
  };
  const onNavigate = (url) => {
    switch (url) {
      case '/logout':
        props.logout();
        window.localStorage.clear();
        window.sessionStorage.clear();
        window.location.reload();
        window.location.href = '/dashboard';
        break;
      case '/tip':
        if (window.location.pathname === '/gift-card') {
          navigate({ pathname: `${APP_CONFIG.BASE_URL}/tip`, search: '?backTo=tip' });
        } else {
          navigate(`${APP_CONFIG.BASE_URL}/tip`);
        }
        break;
      default:
        navigate(`${APP_CONFIG.BASE_URL}${url}`);
        break;
    }
  };

  const footerItemsTypes = [
    [
      {
        type: 16,
        controlUrl: '/home',
        activeLinks: ['/home']
      },
      {
        type: 7,
        controlUrl: '/pick-store',
        activeLinks: ['/pick-store']
      },
      {
        type: 12,
        controlUrl: '/pick-menu',
        activeLinks: []
      },
      {
        type: 6,
        controlUrl: '/orders',
        activeLinks: ['/orders']
      },
      {
        type: 4,
        controlUrl: '',
        activeLinks: ['/selected-cart', '/upsell']
      },
      {
        type: 0,
        controlUrl: '/profile-feature',
        activeLinks: ['/profile-feature']
      },
      {
        type: 17,
        controlUrl: '/mycheck',
        activeLinks: ['/mycheck']
      }
    ],
    [
      {
        type: 1,
        controlUrl: '/home',
        activeLinks: ['/home']
      },
      // {
      //   type: 6,
      //   controlUrl: '/orders',
      //   activeLinks: ['/orders']
      // },
      // {
      //   type: 4,
      //   controlUrl: '',
      //   activeLinks: ['/selected-cart', '/upsell', '/multi-cart']
      // },
      {
        type: props.hideBrowse ? null : 12,
        controlUrl: '/pick-menu',
        activeLinks: []
      },
      {
        type: props.hideBrowse ? null : 2,
        controlUrl: '/browse-category',
        activeLinks: ['/browse-category', '/category-detail']
      },
      {
        type: props.hideBrowse ? null : 3,
        controlUrl: '/wishList',
        activeLinks: ['/wishList']
      },
      {
        type: 0,
        controlUrl: '/profile-feature',
        activeLinks: ['/profile-feature']
      }
    ]
  ];

  const handleMallSelection = (storeId) => {
    const storeData = find(popInData.stores, { id: storeId });
    const consolidateCart = JSON.parse(window.sessionStorage.getItem('cart') || '[]');
    // Clear languageId when switching stores so the new store uses its default language
    window.sessionStorage.removeItem('languageId');
    props.updatePopInData({ store: find(popInData.stores, { id: storeId }) }).then(() => {
      props.clearMenu().then(() => {
        window.sessionStorage.removeItem('menuTypeId');
        window.sessionStorage.removeItem('scrol');
        window.sessionStorage.removeItem('isTile');
        window.sessionStorage.removeItem('menuName');
        props.getMenu(storeId, props.popInData.flowType).then(() => {
          props.replaceCart(consolidateCart);
          if (getObjectValue(() => storeData.brandId, null)) {
            props.getStoreThemeUrl(storeData.brandId, storeData.id);
          }
          if (getObjectValue(() => popInData.startOnHomePage, false) && window.innerWidth < 1023) {
            props.navigate(`${APP_CONFIG.BASE_URL}/home`);
          } else if (!getObjectValue(() => popInData.startOnHomePage, false) && window.innerWidth < 1023) {
            props.navigate(`${APP_CONFIG.BASE_URL}/orders`);
          } else {
            props.navigate(`${APP_CONFIG.BASE_URL}/orders`);
          }
        });
      });
    });
    setShowRestaurants(false);
  };

  return (
    <Fragment>
      {(headerBar || {}).show && (window.innerWidth > 1023) ? (
        <DesktopMenu
          menuItems={footerItemsTypes[props.footerItemsType]}
          // activeMenuItemType={footer.activeMenuItemType}
          navigateTo={navigateTo}
          menus={menus}
          menu={menu}
          popInData={popInData}
          action={action}
          closeOnSamePage={closeOnSamePage}
          wishListCount={wishListCount}
          menusList={props.menusList}
          getCartQuantity={getCartQuantity}
          onClickCartHandler={onClickCartHandler}
          onPreviewSync={onPreviewSync}
          onNavigate={onNavigate}
          closeButton={closeButton}
          headerBar={headerBar}
          footer={footer}
          themeProperties={themeProperties}
          onSearch={onSearch}
          onSearchChange={onSearchChange}
          searchString={search}
          handleLanguageSelection={handleLanguageSelection}
          setSelectedLanguageId={setSelectedLanguageId}
          selectedLanguageId={selectedLanguageId}
          sliderHandler={sliderHandler}
          isCheckoutSlider={isCheckoutSlider}
          ordersSearchString={ordersSearchString}
          menuIndex={props.menuIndex}
        />
      ) : ''}
      {(footer?.show) && !suppressfooter && (
        <div className={cn('footer footerBtm', styles.desktopFooter, (isIos && window.innerWidth < 1024) ? 'd-none' : '', (isOpenDrawer && popInData.flowType !== 2) ? 'd-none' : '')}>
          <FooterComponent
            menuItems={footerItemsTypes[props.footerItemsType]}
            activeMenuItemType={footer.activeMenuItemType}
            menus={menus}
            popInData={popInData}
            action={action}
            closeOnSamePage={closeOnSamePage}
            wishListCount={wishListCount}
            menusList={props.menusList}
            getCartQuantity={getCartQuantity}
            onClickCartHandler={onClickCartHandler}
            onPreviewSync={onPreviewSync}
            onNavigate={onNavigate}
            setActiveCart={setActiveCart}
            activeCart={activeCart}
            navigateTo={navigateTo}
            themeProperties={themeProperties}
            handleSessionTrack={handleSessionTrack}
            setShowRestaurants={setShowRestaurants}
            callServer={props.callServer}
            setNotification={props.setNotification}
            menuIndex={props.menuIndex}
          />
        </div>
      )}
      <Modal isOpen={showRestaurants} toggleModal={() => { setShowRestaurants(!showRestaurants); }}>
        <div>
          <div className="row mx-0">
            <div className="col-lg-4 offset-lg-4 p-lg-0 col-md-6 offset-md-3 col-12 mb-4">
              <div className="row mx-0">
                <div className="col-12 mt-1">
                  <div className="row mt-2 mb-2 fw-600 d-flex justify-content-between">
                    <span>{CUSTOM_MESSAGES().SELECT_STORE_ORDER_FROM}</span>
                    <div className="text-right btn-as-text color-secondary">
                      <button type="button" className="bg-transparent border-0 icon-od fs-12 icon-od-close" aria-label="close" onClick={() => { setShowRestaurants(false); }} />
                    </div>
                  </div>
                  <div className="row">
                    <MallMenuModal
                      popInData={popInData}
                      handleMallSelection={handleMallSelection}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};
const mapStateToProps = ({
  oauth,
  header,
  orders,
  browse,
  theme,
  controller
}) => (
  {
    userdata: oauth.userdata,
    footer: header.footer,
    footerItemsType: header.footerItemsType,
    menus: orders.menus,
    menuIndex: orders.menuIndex,
    popInData: controller.popInData || {},
    action: header.action,
    closeButton: header.closeButton,
    menu: header.menu,
    // wishListCount: browse.wishList.length,
    hideBrowse: browse.hideBrowse,
    menusList: orders.menusList,
    cart: orders.cart,
    menuItems: orders.menuItemsHashTable,
    multiCartInfo: orders.multiCartInfo,
    headerBar: header.headerBar,
    themeProperties: theme.themeProperties || controller?.popInData?.theme,
    screenMenuItemsList: orders.screenMenuItemsList,
    // wishListCount: browse.favouriteBrowseItems && browse.favouriteBrowseItems.length,
    wishListCount: browse?.favouriteBrowseItems?.length || 0,

  }
);

const mapDispatchToProps = dispatch => bindActionCreators({
  toggleFooter,
  toggleCancelButtonSamePage,
  updateMultiCart,
  logout,
  sessionTrack,
  onSearchItem,
  pushMenuItemsByScreenId,
  clearMenu,
  replaceCart,
  getMultiMenu,
  upsellCheck,
  getMenu,
  updatePopInData,
  setNotification,
  getStoreThemeUrl,
  getLanguageThemeUrl,
  callServer,
  getMenuBasedOnLanguage,
  onContinousScrollSearchItem
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Footer);
